import { CSSProperties, useMemo } from 'react';

interface IDesign {
  backgroundColor?: string;
  textColor: string;
  padding?: boolean;
}

export const createBadgeStyle = (design?: IDesign) => {
  if (!design) {
    return undefined;
  }

  const { backgroundColor, textColor, padding } = design;

  const style: CSSProperties = {
    backgroundColor: backgroundColor ?? 'transparent',
    color: textColor,
  };

  if (!padding) {
    style.padding = 0;
    style.marginBottom = 0;
  }
  return style;
};

export default (flag?: IFlag) =>
  useMemo(() => {
    if (!flag || !flag.productBanner?.design) {
      return undefined;
    }

    return createBadgeStyle(flag.productBanner?.design) as CSSProperties;
  }, [flag]);
